@if (surveyService.is_widget) {
    <app-widget-header></app-widget-header>
}
<router-outlet></router-outlet>
<!-- loading spinner | enable with a conditional -->
<!-- <app-loading-screen></app-loading-screen> -->